export const ROUTE_NAMES = {
  LIST: 'trades-list'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'trades'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  }
]
